import m from 'mithril';
import { TopPage } from './top-page';

const root = document.getElementById('root');
m.route(root, "/", {
  "/": TopPage,
});